import { APPLICATION_ROUTES } from "../types/routes"

export const getAuthorPageUrl = (displayAuthoryPage: boolean, isMainDomain: boolean, userSlug?: string) => {
    if (displayAuthoryPage) {
        if (isMainDomain) return `${APPLICATION_ROUTES.AUTHOR_PAGE.replace("[author]", userSlug || "")}`
        return APPLICATION_ROUTES.HOMEPAGE // custom domain or subdomain
    }
    return undefined
}